import { Credentials } from 'src/containers/Credentials';
import { PageGuard } from 'src/pages/PageGuard';
import { PAGES_CONFIG } from '../config';

export const CredentialsPage = () => (
  <PageGuard hasAccess={PAGES_CONFIG.endpoints.hasAccess}>
    <Credentials />
  </PageGuard>
);
